export const OrderApiRoutes = {
    Create: '/order/create',
    Subscribe: '/subscription/order'
};
export const ReviewApiRoutes = {
    GetProductReviewList: "/products/:id/reviews",
    GetAllReviewsList: "/reviews/all",
    GetProductReviewAvatarImage: '/products/review/image/:imageName',
};
export const ProductApiRoutes = {
    GetProductList: "/products",
};
export const LegalDocumentsApiRoutes = {
    GetLegalDocumentsList: "/legal/documents/actual",
};
export const TariffApiRoutes = {
    GetTariff: "/tariffs/web/:uuid"
};
export const AuthApiRoutes = {
    Auth: '/client/auth',
};
